<template>
  <div class="embed-responsive">
    <Title :title-name="pageTitle.titleName" :title-link="pageTitle.titleLink" />
    <div class="container-fluid">
      <iframe style="margin-top: 54px" :src="iframeUrl" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'

export default {
  name: 'MyDocument',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pageTitle: {},
      iframeUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: ''
    })
  },
  watch: {
    title: function (el) {
      if (el && el.IframePopup) {
        this.pageTitle = el.IframePopup
      }
    }
  },
  created() {
    this.validateAndSetIframeUrl()
    if (this.title && this.title.IframePopup) {
      this.pageTitle = this.title.IframePopup
    }
  },
  methods: {
    validateAndSetIframeUrl() {
      const url = this.$route.query.url

      if (!url) {
        this.$router.push('/page-error?error=No URL provided')
        return
      }

      try {
        const urlObj = new URL(url, window.location.origin)

        // Only allow HTTP(S) URL's
        if (urlObj.protocol !== 'https:' && urlObj.protocol !== 'http:') {
          console.error('Only HTTP(S) URLs are allowed')
          this.$router.push('/page-error?error=Only HTTP(S) URLs are allowed')
          return
        }

        this.iframeUrl = url
      } catch (e) {
        console.error('Invalid URL:', e)
        this.$router.push('/page-error?error=Invalid URL format')
      }
    }
  }
}
</script>
